import { render, staticRenderFns } from "./shop-item.vue?vue&type=template&id=a651db20&scoped=true"
import script from "./shop-item.vue?vue&type=script&lang=js"
export * from "./shop-item.vue?vue&type=script&lang=js"
import style0 from "./shop-item.vue?vue&type=style&index=0&id=a651db20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a651db20",
  null
  
)

export default component.exports